import React from "react";

function PlayButtonIcon({ fill, ...restProps }) {
  return (
   <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M40.5 1.5C61.763 1.5 79 18.737 79 40C79 61.263 61.763 78.5 40.5 78.5C19.237 78.5 2 61.263 2 40C2 18.737 19.237 1.5 40.5 1.5Z"
        fill="white"
        fill-opacity="0.1"
      />
      <path
        d="M40.5 1.5C61.763 1.5 79 18.737 79 40C79 61.263 61.763 78.5 40.5 78.5C19.237 78.5 2 61.263 2 40C2 18.737 19.237 1.5 40.5 1.5Z"
        stroke="white"
        stroke-width="3"
      />
      <path
        d="M56.75 37.904C58.4167 38.8355 58.4167 41.1645 56.75 42.096L34.25 54.6721C32.5833 55.6037 30.5 54.4392 30.5 52.5761L30.5 27.4239C30.5 25.5608 32.5833 24.3963 34.25 25.3279L56.75 37.904Z"
        fill="white"
      />
    </svg>
  );
}

export default PlayButtonIcon;
